export default "__VITE_ASSET__DNiOhCDB__"